import { jsxs as Re, Fragment as Ee, jsx as ee } from "react/jsx-runtime";
import H, { useRef as q, useState as se, useEffect as ie, useMemo as Fe, useLayoutEffect as Oe, useContext as Le } from "react";
import { useTranslation as $e } from "react-i18next";
import { ThemeContext as ke, Switcher as Me, Input as Pe } from "@forma/forma-ui-kit";
import { PRODUCT_VAT_IDS as je } from "../../../../../helpers/productsCalcFunctions.js";
function pe(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
}
var te;
(function(e) {
  e.event = "event", e.props = "prop";
})(te || (te = {}));
function K() {
}
function We(e) {
  var t, r = void 0;
  return function() {
    for (var n = [], a = arguments.length; a--; )
      n[a] = arguments[a];
    return t && n.length === t.length && n.every(function(o, l) {
      return o === t[l];
    }) || (t = n, r = e.apply(void 0, n)), r;
  };
}
function re(e) {
  return !!(e || "").match(/\d/);
}
function J(e) {
  return e == null;
}
function Ke(e) {
  return typeof e == "number" && isNaN(e);
}
function xe(e) {
  return J(e) || Ke(e) || typeof e == "number" && !isFinite(e);
}
function Se(e) {
  return e.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}
function Ue(e) {
  switch (e) {
    case "lakh":
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
    case "wan":
      return /(\d)(?=(\d{4})+(?!\d))/g;
    case "thousand":
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}
function Ge(e, t, r) {
  var n = Ue(r), a = e.search(/[1-9]/);
  return a = a === -1 ? e.length : a, e.substring(0, a) + e.substring(a, e.length).replace(n, "$1" + t);
}
function Ze(e) {
  var t = q(e);
  t.current = e;
  var r = q(function() {
    for (var n = [], a = arguments.length; a--; )
      n[a] = arguments[a];
    return t.current.apply(t, n);
  });
  return r.current;
}
function ce(e, t) {
  t === void 0 && (t = !0);
  var r = e[0] === "-", n = r && t;
  e = e.replace("-", "");
  var a = e.split("."), o = a[0], l = a[1] || "";
  return {
    beforeDecimal: o,
    afterDecimal: l,
    hasNegation: r,
    addNegation: n
  };
}
function ze(e) {
  if (!e)
    return e;
  var t = e[0] === "-";
  t && (e = e.substring(1, e.length));
  var r = e.split("."), n = r[0].replace(/^0+/, "") || "0", a = r[1] || "";
  return (t ? "-" : "") + n + (a ? "." + a : "");
}
function Ve(e, t, r) {
  for (var n = "", a = r ? "0" : "", o = 0; o <= t - 1; o++)
    n += e[o] || a;
  return n;
}
function de(e, t) {
  return Array(t + 1).join(e);
}
function be(e) {
  var t = e + "", r = t[0] === "-" ? "-" : "";
  r && (t = t.substring(1));
  var n = t.split(/[eE]/g), a = n[0], o = n[1];
  if (o = Number(o), !o)
    return r + a;
  a = a.replace(".", "");
  var l = 1 + o, x = a.length;
  return l < 0 ? a = "0." + de("0", Math.abs(l)) + a : l >= x ? a = a + de("0", l - x) : a = (a.substring(0, l) || "0") + "." + a.substring(l), r + a;
}
function ge(e, t, r) {
  if (["", "-"].indexOf(e) !== -1)
    return e;
  var n = (e.indexOf(".") !== -1 || r) && t, a = ce(e), o = a.beforeDecimal, l = a.afterDecimal, x = a.hasNegation, V = parseFloat("0." + (l || "0")), g = l.length <= t ? "0." + l : V.toFixed(t), S = g.split("."), m = o.split("").reverse().reduce(function(w, y, f) {
    return w.length > f ? (Number(w[0]) + Number(y)).toString() + w.substring(1, w.length) : y + w;
  }, S[0]), h = Ve(S[1] || "", t, r), p = x ? "-" : "", s = n ? "." : "";
  return "" + p + m + s + h;
}
function G(e, t) {
  if (e.value = e.value, e !== null) {
    if (e.createTextRange) {
      var r = e.createTextRange();
      return r.move("character", t), r.select(), !0;
    }
    return e.selectionStart || e.selectionStart === 0 ? (e.focus(), e.setSelectionRange(t, t), !0) : (e.focus(), !1);
  }
}
var we = We(function(e, t) {
  for (var r = 0, n = 0, a = e.length, o = t.length; e[r] === t[r] && r < a; )
    r++;
  for (; e[a - 1 - n] === t[o - 1 - n] && o - n > r && a - n > r; )
    n++;
  return {
    from: { start: r, end: a - n },
    to: { start: r, end: o - n }
  };
});
function He(e, t, r) {
  return Math.min(Math.max(e, t), r);
}
function fe(e) {
  return Math.max(e.selectionStart, e.selectionEnd);
}
function qe() {
  return typeof navigator < "u" && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function Je(e) {
  return {
    from: {
      start: 0,
      end: 0
    },
    to: {
      start: 0,
      end: e.length
    },
    lastValue: ""
  };
}
function Qe(e) {
  var t = e.currentValue, r = e.formattedValue, n = e.currentValueIndex, a = e.formattedValueIndex;
  return t[n] === r[a];
}
function Xe(e, t, r, n, a, o, l) {
  l === void 0 && (l = Qe);
  var x = a.findIndex(function(L) {
    return L;
  }), V = e.slice(0, x);
  !t && !r.startsWith(V) && (t = V, r = V + r, n = n + V.length);
  for (var g = r.length, S = e.length, m = {}, h = new Array(g), p = 0; p < g; p++) {
    h[p] = -1;
    for (var s = 0, w = S; s < w; s++) {
      var y = l({
        currentValue: r,
        lastValue: t,
        formattedValue: e,
        currentValueIndex: p,
        formattedValueIndex: s
      });
      if (y && m[s] !== !0) {
        h[p] = s, m[s] = !0;
        break;
      }
    }
  }
  for (var f = n; f < g && (h[f] === -1 || !o(r[f])); )
    f++;
  var N = f === g || h[f] === -1 ? S : h[f];
  for (f = n - 1; f > 0 && h[f] === -1; )
    f--;
  var B = f === -1 || h[f] === -1 ? 0 : h[f] + 1;
  return B > N ? N : n - B < N - n ? B : N;
}
function me(e, t, r, n) {
  var a = e.length;
  if (t = He(t, 0, a), n === "left") {
    for (; t >= 0 && !r[t]; )
      t--;
    t === -1 && (t = r.indexOf(!0));
  } else {
    for (; t <= a && !r[t]; )
      t++;
    t > a && (t = r.lastIndexOf(!0));
  }
  return t === -1 && (t = a), t;
}
function Ye(e) {
  for (var t = Array.from({ length: e.length + 1 }).map(function() {
    return !0;
  }), r = 0, n = t.length; r < n; r++)
    t[r] = !!(re(e[r]) || re(e[r - 1]));
  return t;
}
function ye(e, t, r, n, a, o) {
  o === void 0 && (o = K);
  var l = Ze(function(s, w) {
    var y, f;
    return xe(s) ? (f = "", y = "") : typeof s == "number" || w ? (f = typeof s == "number" ? be(s) : s, y = n(f)) : (f = a(s, void 0), y = n(f)), { formattedValue: y, numAsString: f };
  }), x = se(function() {
    return l(J(e) ? t : e, r);
  }), V = x[0], g = x[1], S = function(s, w) {
    s.formattedValue !== V.formattedValue && g({
      formattedValue: s.formattedValue,
      numAsString: s.value
    }), o(s, w);
  }, m = e, h = r;
  J(e) && (m = V.numAsString, h = !0);
  var p = l(m, h);
  return Fe(function() {
    g(p);
  }, [p.formattedValue]), [V, S];
}
function et(e) {
  return e.replace(/[^0-9]/g, "");
}
function tt(e) {
  return e;
}
function rt(e) {
  var t = e.type;
  t === void 0 && (t = "text");
  var r = e.displayType;
  r === void 0 && (r = "input");
  var n = e.customInput, a = e.renderText, o = e.getInputRef, l = e.format;
  l === void 0 && (l = tt);
  var x = e.removeFormatting;
  x === void 0 && (x = et);
  var V = e.defaultValue, g = e.valueIsNumericString, S = e.onValueChange, m = e.isAllowed, h = e.onChange;
  h === void 0 && (h = K);
  var p = e.onKeyDown;
  p === void 0 && (p = K);
  var s = e.onMouseUp;
  s === void 0 && (s = K);
  var w = e.onFocus;
  w === void 0 && (w = K);
  var y = e.onBlur;
  y === void 0 && (y = K);
  var f = e.value, N = e.getCaretBoundary;
  N === void 0 && (N = Ye);
  var B = e.isValidInputCharacter;
  B === void 0 && (B = re);
  var L = e.isCharacterSame, $ = pe(e, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "removeFormatting", "defaultValue", "valueIsNumericString", "onValueChange", "isAllowed", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value", "getCaretBoundary", "isValidInputCharacter", "isCharacterSame"]), U = ye(f, V, !!g, l, x, S), P = U[0], b = P.formattedValue, k = P.numAsString, j = U[1], M = q({ formattedValue: b, numAsString: k }), Z = function(i, u) {
    M.current = { formattedValue: i.formattedValue, numAsString: i.value }, j(i, u);
  }, W = se(!1), Q = W[0], X = W[1], c = q(null), v = q({
    setCaretTimeout: null,
    focusTimeout: null
  });
  ie(function() {
    return X(!0), function() {
      clearTimeout(v.current.setCaretTimeout), clearTimeout(v.current.focusTimeout);
    };
  }, []);
  var E = l, D = function(i, u) {
    var d = parseFloat(u);
    return {
      formattedValue: i,
      value: u,
      floatValue: isNaN(d) ? void 0 : d
    };
  }, C = function(i, u, d) {
    i.selectionStart === 0 && i.selectionEnd === i.value.length || (G(i, u), v.current.setCaretTimeout = setTimeout(function() {
      i.value === d && i.selectionStart !== i.selectionEnd && G(i, u);
    }, 0));
  }, A = function(i, u, d) {
    return me(i, u, N(i), d);
  }, O = function(i, u, d) {
    var I = N(u), T = Xe(u, b, i, d, I, B, L);
    return T = me(u, T, I), T;
  }, ae = function(i) {
    var u = i.formattedValue;
    u === void 0 && (u = "");
    var d = i.input, I = i.setCaretPosition;
    I === void 0 && (I = !0);
    var T = i.source, _ = i.event, R = i.numAsString, F = i.caretPos;
    if (d) {
      if (F === void 0 && I) {
        var Y = i.inputValue || d.value, le = fe(d);
        d.value = u, F = O(Y, u, le);
      }
      d.value = u, I && F !== void 0 && C(d, F, u);
    }
    u !== b && Z(D(u, R), { event: _, source: T });
  };
  ie(function() {
    var i = M.current, u = i.formattedValue, d = i.numAsString;
    b !== u && (b !== k || u !== d) && Z(D(b, k), {
      event: void 0,
      source: te.props
    });
  }, [b, k]);
  var ue = c.current ? fe(c.current) : void 0, ne = typeof window < "u" ? Oe : ie;
  ne(function() {
    var i = c.current;
    if (b !== M.current.formattedValue && i) {
      var u = O(M.current.formattedValue, b, ue);
      i.value = b, C(i, u, b);
    }
  }, [b]);
  var _e = function(i, u, d) {
    var I = we(b, i), T = Object.assign(Object.assign({}, I), { lastValue: b }), _ = x(i, T), R = E(_);
    if (_ = x(R, void 0), m && !m(D(R, _))) {
      var F = u.target, Y = fe(F), le = O(i, b, Y);
      return F.value = b, C(F, le, b), !1;
    }
    return ae({
      formattedValue: R,
      numAsString: _,
      inputValue: i,
      event: u,
      source: d,
      setCaretPosition: !0,
      input: u.target
    }), !0;
  }, Ne = function(i) {
    var u = i.target, d = u.value, I = _e(d, i, te.event);
    I && h(i);
  }, De = function(i) {
    var u = i.target, d = i.key, I = u.selectionStart, T = u.selectionEnd, _ = u.value;
    _ === void 0 && (_ = "");
    var R;
    if (d === "ArrowLeft" || d === "Backspace" ? R = Math.max(I - 1, 0) : d === "ArrowRight" ? R = Math.min(I + 1, _.length) : d === "Delete" && (R = I), R === void 0 || I !== T) {
      p(i);
      return;
    }
    var F = R;
    if (d === "ArrowLeft" || d === "ArrowRight") {
      var Y = d === "ArrowLeft" ? "left" : "right";
      F = A(_, R, Y), F !== R && i.preventDefault();
    } else
      d === "Delete" && !B(_[R]) ? F = A(_, R, "right") : d === "Backspace" && !B(_[R]) && (F = A(_, R, "left"));
    F !== R && C(u, F, _), i.isUnitTestRun && C(u, F, _), p(i);
  }, Ce = function(i) {
    var u = i.target, d = u.selectionStart, I = u.selectionEnd, T = u.value;
    if (T === void 0 && (T = ""), d === I) {
      var _ = A(T, d);
      _ !== d && C(u, _, T);
    }
    s(i);
  }, Ie = function(i) {
    i.persist && i.persist();
    var u = i.target;
    c.current = u, v.current.focusTimeout = setTimeout(function() {
      var d = u.selectionStart, I = u.selectionEnd, T = u.value;
      T === void 0 && (T = "");
      var _ = A(T, d);
      _ !== d && !(d === 0 && I === T.length) && C(u, _, T), w(i);
    }, 0);
  }, Te = function(i) {
    c.current = null, clearTimeout(v.current.focusTimeout), clearTimeout(v.current.setCaretTimeout), y(i);
  }, Ae = Q && qe() ? "numeric" : void 0, ve = Object.assign({ inputMode: Ae }, $, {
    type: t,
    value: b,
    onChange: Ne,
    onKeyDown: De,
    onMouseUp: Ce,
    onFocus: Ie,
    onBlur: Te
  });
  if (r === "text")
    return a ? H.createElement(H.Fragment, null, a(b, $) || null) : H.createElement("span", Object.assign({}, $, { ref: o }), b);
  if (n) {
    var Be = n;
    return H.createElement(Be, Object.assign({}, ve, { ref: o }));
  }
  return H.createElement("input", Object.assign({}, ve, { ref: o }));
}
function he(e, t) {
  var r = t.decimalScale, n = t.fixedDecimalScale, a = t.prefix;
  a === void 0 && (a = "");
  var o = t.suffix;
  o === void 0 && (o = "");
  var l = t.allowNegative, x = t.thousandsGroupStyle;
  if (x === void 0 && (x = "thousand"), e === "" || e === "-")
    return e;
  var V = oe(t), g = V.thousandSeparator, S = V.decimalSeparator, m = r !== 0 && e.indexOf(".") !== -1 || r && n, h = ce(e, l), p = h.beforeDecimal, s = h.afterDecimal, w = h.addNegation;
  return r !== void 0 && (s = Ve(s, r, !!n)), g && (p = Ge(p, g, x)), a && (p = a + p), o && (s = s + o), w && (p = "-" + p), e = p + (m && S || "") + s, e;
}
function oe(e) {
  var t = e.decimalSeparator;
  t === void 0 && (t = ".");
  var r = e.thousandSeparator, n = e.allowedDecimalSeparators;
  return r === !0 && (r = ","), n || (n = [t, "."]), {
    decimalSeparator: t,
    thousandSeparator: r,
    allowedDecimalSeparators: n
  };
}
function at(e, t) {
  e === void 0 && (e = "");
  var r = new RegExp("(-)"), n = new RegExp("(-)(.)*(-)"), a = r.test(e), o = n.test(e);
  return e = e.replace(/-/g, ""), a && !o && t && (e = "-" + e), e;
}
function nt(e, t) {
  return new RegExp("(^-)|[0-9]|" + Se(e), t ? "g" : void 0);
}
function it(e, t, r) {
  return e === "" ? !0 : !(t != null && t.match(/\d/)) && !(r != null && r.match(/\d/)) && typeof e == "string" && !isNaN(Number(e));
}
function ot(e, t, r) {
  var n;
  t === void 0 && (t = Je(e));
  var a = r.allowNegative, o = r.prefix;
  o === void 0 && (o = "");
  var l = r.suffix;
  l === void 0 && (l = "");
  var x = r.decimalScale, V = t.from, g = t.to, S = g.start, m = g.end, h = oe(r), p = h.allowedDecimalSeparators, s = h.decimalSeparator, w = e[m] === s;
  if (re(e) && (e === o || e === l) && t.lastValue === "")
    return e;
  if (m - S === 1 && p.indexOf(e[S]) !== -1) {
    var y = x === 0 ? "" : s;
    e = e.substring(0, S) + y + e.substring(S + 1, e.length);
  }
  var f = function(v, E, D) {
    var C = !1, A = !1;
    o.startsWith("-") ? C = !1 : v.startsWith("--") ? (C = !1, A = !0) : l.startsWith("-") && v.length === l.length ? C = !1 : v[0] === "-" && (C = !0);
    var O = C ? 1 : 0;
    return A && (O = 2), O && (v = v.substring(O), E -= O, D -= O), { value: v, start: E, end: D, hasNegation: C };
  }, N = f(e, S, m), B = N.hasNegation;
  n = N, e = n.value, S = n.start, m = n.end;
  var L = f(t.lastValue, V.start, V.end), $ = L.start, U = L.end, P = L.value, b = e.substring(S, m);
  e.length && P.length && ($ > P.length - l.length || U < o.length) && !(b && l.startsWith(b)) && (e = P);
  var k = 0;
  e.startsWith(o) ? k += o.length : S < o.length && (k = S), e = e.substring(k), m -= k;
  var j = e.length, M = e.length - l.length;
  e.endsWith(l) ? j = M : (m > M || m > e.length - l.length) && (j = m), e = e.substring(0, j), e = at(B ? "-" + e : e, a), e = (e.match(nt(s, !0)) || []).join("");
  var Z = e.indexOf(s);
  e = e.replace(new RegExp(Se(s), "g"), function(v, E) {
    return E === Z ? "." : "";
  });
  var W = ce(e, a), Q = W.beforeDecimal, X = W.afterDecimal, c = W.addNegation;
  return g.end - g.start < V.end - V.start && Q === "" && w && !parseFloat(X) && (e = c ? "-" : ""), e;
}
function ut(e, t) {
  var r = t.prefix;
  r === void 0 && (r = "");
  var n = t.suffix;
  n === void 0 && (n = "");
  var a = Array.from({ length: e.length + 1 }).map(function() {
    return !0;
  }), o = e[0] === "-";
  a.fill(!1, 0, r.length + (o ? 1 : 0));
  var l = e.length;
  return a.fill(!1, l - n.length + 1, l + 1), a;
}
function lt(e) {
  var t = oe(e), r = t.thousandSeparator, n = t.decimalSeparator, a = e.prefix;
  a === void 0 && (a = "");
  var o = e.allowNegative;
  if (o === void 0 && (o = !0), r === n)
    throw new Error(`
        Decimal separator can't be same as thousand separator.
        thousandSeparator: ` + r + ` (thousandSeparator = {true} is same as thousandSeparator = ",")
        decimalSeparator: ` + n + ` (default value for decimalSeparator is .)
     `);
  return a.startsWith("-") && o && (console.error(`
      Prefix can't start with '-' when allowNegative is true.
      prefix: ` + a + `
      allowNegative: ` + o + `
    `), o = !1), Object.assign(Object.assign({}, e), { allowNegative: o });
}
function ft(e) {
  e = lt(e), e.decimalSeparator, e.allowedDecimalSeparators, e.thousandsGroupStyle;
  var t = e.suffix, r = e.allowNegative, n = e.allowLeadingZeros, a = e.onKeyDown;
  a === void 0 && (a = K);
  var o = e.onBlur;
  o === void 0 && (o = K);
  var l = e.thousandSeparator, x = e.decimalScale, V = e.fixedDecimalScale, g = e.prefix;
  g === void 0 && (g = "");
  var S = e.defaultValue, m = e.value, h = e.valueIsNumericString, p = e.onValueChange, s = pe(e, ["decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "suffix", "allowNegative", "allowLeadingZeros", "onKeyDown", "onBlur", "thousandSeparator", "decimalScale", "fixedDecimalScale", "prefix", "defaultValue", "value", "valueIsNumericString", "onValueChange"]), w = oe(e), y = w.decimalSeparator, f = w.allowedDecimalSeparators, N = function(c) {
    return he(c, e);
  }, B = function(c, v) {
    return ot(c, v, e);
  }, L = J(m) ? S : m, $ = h ?? it(L, g, t);
  J(m) ? J(S) || ($ = $ || typeof S == "number") : $ = $ || typeof m == "number";
  var U = function(c) {
    return xe(c) ? c : (typeof c == "number" && (c = be(c)), $ && typeof x == "number" ? ge(c, x, !!V) : c);
  }, P = ye(U(m), U(S), !!$, N, B, p), b = P[0], k = b.numAsString, j = b.formattedValue, M = P[1], Z = function(c) {
    var v = c.target, E = c.key, D = v.selectionStart, C = v.selectionEnd, A = v.value;
    if (A === void 0 && (A = ""), D !== C) {
      a(c);
      return;
    }
    E === "Backspace" && A[0] === "-" && D === g.length + 1 && r && G(v, 1), x && V && (E === "Backspace" && A[D - 1] === y ? (G(v, D - 1), c.preventDefault()) : E === "Delete" && A[D] === y && c.preventDefault()), f != null && f.includes(E) && A[D] === y && G(v, D + 1);
    var O = l === !0 ? "," : l;
    E === "Backspace" && A[D - 1] === O && G(v, D - 1), E === "Delete" && A[D] === O && G(v, D + 1), a(c);
  }, W = function(c) {
    var v = k;
    if (v.match(/\d/g) || (v = ""), n || (v = ze(v)), V && x && (v = ge(v, x, V)), v !== k) {
      var E = he(v, e);
      M({
        formattedValue: E,
        value: v,
        floatValue: parseFloat(v)
      }, {
        event: c,
        source: te.event
      });
    }
    o(c);
  }, Q = function(c) {
    return c === y ? !0 : re(c);
  }, X = function(c) {
    var v = c.currentValue, E = c.lastValue, D = c.formattedValue, C = c.currentValueIndex, A = c.formattedValueIndex, O = v[C], ae = D[A], ue = we(E, v), ne = ue.to;
    return C >= ne.start && C < ne.end && f && f.includes(O) && ae === y ? !0 : O === ae;
  };
  return Object.assign(Object.assign({}, s), {
    value: j,
    valueIsNumericString: !1,
    isValidInputCharacter: Q,
    isCharacterSame: X,
    onValueChange: M,
    format: N,
    removeFormatting: B,
    getCaretBoundary: function(c) {
      return ut(c, e);
    },
    onKeyDown: Z,
    onBlur: W
  });
}
function st(e) {
  var t = ft(e);
  return H.createElement(rt, Object.assign({}, t));
}
const ct = "forma-filling__fill-products-table-input__input", vt = "forma-filling__fill-products-table-input__tooltip", dt = "forma-filling__fill-products-table-input__switcher", gt = "forma-filling__fill-products-table-input__switcherLabel", mt = "forma-filling__fill-products-table-input__textValue", z = {
  input: ct,
  tooltip: vt,
  switcher: dt,
  switcherLabel: gt,
  textValue: mt
}, bt = ({
  id: e,
  productId: t,
  type: r,
  value: n = "",
  isSimilar: a,
  canApplyToAll: o,
  onChangeItem: l,
  onChangeAll: x,
  readOnly: V
}) => {
  const g = q(null), { t: S } = $e(), { lang: m } = Le(ke), [h, p] = se(!1), s = h && !!n && !a && o && !!x, w = je.includes(e) && n === S("uikit:without_vat") && !h, y = r && ["percentage", "money", "decimal"].includes(r);
  return ie(() => {
    if (!g.current)
      return;
    const f = g.current.closest("td"), N = f.closest("table");
    let B = "auto", L = `${f.offsetWidth / 2 - g.current.offsetWidth / 2}px`;
    f.offsetLeft || (L = "0px"), f.offsetLeft + f.offsetWidth === N.offsetWidth && (L = "auto", B = "0px"), g.current.style.opacity = "1", g.current.style.top = `${-g.current.offsetHeight - 6}px`, g.current.style.left = L, g.current.style.right = B;
  }, [g.current, h]), /* @__PURE__ */ Re(Ee, { children: [
    s && /* @__PURE__ */ ee("div", { className: z.tooltip, onClick: () => x(n), ref: g, children: /* @__PURE__ */ ee(
      Me,
      {
        id: `apply_to_all${t}_${e}`,
        name: "apply_to_all",
        size: "small",
        checked: a,
        label: S("uikit:apply_to_all"),
        containerClass: z.switcher,
        labelClass: z.switcherLabel
      }
    ) }),
    w && /* @__PURE__ */ ee("span", { className: z.textValue, children: n }),
    y ? /* @__PURE__ */ ee(
      st,
      {
        id: `product_input_${t}_${e}`,
        name: `product_value_${t}_${e}`,
        className: z.input,
        onChange: (f) => l(f.target.value),
        onFocus: () => p(!0),
        onBlur: () => setTimeout(() => p(!1), 250),
        value: n,
        thousandSeparator: m === "ru" ? " " : ",",
        decimalSeparator: m === "ru" ? "," : ".",
        decimalScale: 2,
        fixedDecimalScale: r === "money",
        suffix: r === "percentage" ? "%" : void 0,
        inputMode: "decimal",
        isAllowed: (f) => {
          const { floatValue: N } = f;
          return N === void 0 || N < (r === "percentage" ? 100 : 1e9);
        },
        readOnly: V
      }
    ) : /* @__PURE__ */ ee(
      Pe,
      {
        id: `product_input_${t}_${e}`,
        name: `product_value_${t}_${e}`,
        className: z.input,
        onChange: (f) => l(f.target.value),
        onFocus: () => p(!0),
        onBlur: () => setTimeout(() => p(!1), 250),
        maxLength: 250,
        value: n,
        readOnly: V
      }
    )
  ] });
};
export {
  bt as default
};
